<template>
  <section>
    <Feature :title="$t('RECEIVING_DOWNLOAD')" :iconClass="'fa-database'">
      <FormRow :fieldNameArr="['*' + $t('AREA'), '*' + $t('DATE_FROM'), '*' + $t('DATE_TO')]">
        <Select filterable v-model="areaValue" style="width: 200px" slot="a" @on-change="changeArea($event)">
          <Option v-for="(item, index) in areaList" :value="item.value" :key="index">{{ item.text }}</Option>
        </Select>
        <DatePicker v-model="validFrom" type="datetime" :placeholder="$t('CHOOSE') + $t('DATE_FROM')" format="yyyy-MM-dd HH:mm:ss" slot="b" @on-change="changeValidFrom($event)"></DatePicker>
        <DatePicker v-model="validTo" type="datetime" :placeholder="$t('CHOOSE') + $t('DATE_TO')" format="yyyy-MM-dd HH:mm:ss" slot="c" @on-change="changeValidTo($event)"></DatePicker>
      </FormRow>
      <ButtonRow>
        <Button type="primary" slot="0" @click="search">{{ $t('SUBMIT') }}</Button>
      </ButtonRow>
    </Feature>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { Translate, DateTimeToString } from "@/util/common"
import { AlertInfo } from "@/util/alert"

export default {
  name: "ReceivingDownload",
  created() {
  },
  data() {
    return {
      areaValue: 'TW00',
      areaList: [{ text: 'TW', value: 'TW00' }, { text: 'CN', value: 'CN00' }, { text: 'TH', value: 'TH00' }],
      validFrom: '',
      validTo: '',
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage"]),
    ...mapActions(["toggleLoading"]),
    search() {
      const vueInstance = this
      let errorMessage = vueInstance.valid(vueInstance.areaValue, vueInstance.validFrom, vueInstance.validTo)
      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => {
        })
      } else {
        vueInstance.dataList = []
        vueInstance.toggleLoading(true)

        let inputValidFrom = vueInstance.validFrom
        if (typeof vueInstance.validFrom === "object") {
          inputValidFrom = encodeURIComponent(DateTimeToString(vueInstance.validFrom, "-"))
        } 

        let inputValidTo = vueInstance.validTo
        if (typeof vueInstance.validTo === "object") {
          inputValidTo = encodeURIComponent(DateTimeToString(vueInstance.validTo, "-"))
        } 
        
        vueInstance.$consignmentHttp
          .get("/gr/task/receiving?client-id=" + vueInstance.areaValue +
            "&entry-start-from=" + inputValidFrom +
            "&entry-start-to=" + inputValidTo, JSON.stringify(buildCateria(vueInstance)))
          .then((response) => {
            this.toggleLoading(false)
            if (response.data) {
              this.$Swal.fire({
                icon: "info",
                title: response.data.title,
                text: response.data.content[0].status,
              })
            }
          })
          .catch((error) => {
            if (error.response.status == 444) {
              let text = vueInstance.$buildErrorMessage(error)
              vueInstance.$Swal.fire({
                icon: "error",
                title: Translate("COMMON_MESSAGE_ERROR"),
                text,
              })
            }
          })
      }
    },
    valid(area, validFrom, validTo) {
      let errorMessage = ""
      if (!area) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('AREA') + " <br>"
      }
      if (!validFrom) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('DATE_FROM') + " <br>"
      }
      if (!validTo) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('DATE_TO') + " <br>"
      }
      return errorMessage
    },
    changeArea(value) {
      this.areaValue = value
    },
    changeValidFrom(value) {
      this.validFrom = value
    },
    changeValidTo(value) {
      this.validTo = value
    }
  },
  computed: {
  }
}

function buildCateria(vueInstance) {
  let inputValidFrom = vueInstance.validFrom
  if (typeof vueInstance.validFrom == "object") {
    inputValidFrom = encodeURIComponent(DateTimeToString(vueInstance.validFrom, "-"))
  } 

  let inputValidTo = vueInstance.validTo
  if (typeof vueInstance.validTo == "object") {
    inputValidTo = encodeURIComponent(DateTimeToString(vueInstance.validTo, "-"))
  } 
  return {
    area: vueInstance.area,
    validFrom: vueInstance.validFrom != "" && vueInstance.validFrom != null ? inputValidFrom : null,
    validTo: vueInstance.validTo != "" && vueInstance.validTo != null ? inputValidTo : null
  }
}

</script>

<style scoped>
::v-deep .ivu-picker-confirm .ivu-btn {
  width: auto;
}
</style>
